<template>
  <div data-test="cloneEntryRules">
    <br />
    <b>{{
      $t(
        "events:EventCardLarge.CloneModal.entryRulesCloningSettings.subheading",
        "Choose setting for cloning of competitions´ entry rules"
      )
    }}</b>
    <br />
    <v-radio-group v-model="cloneValue">
      <v-radio
        :label="
          $t(
            'events:EventCardLarge.CloneModal.entryRulesCloningSettings.useFromSourceEvent.label',
            'Keep competitions entry rule conditions from source event'
          )
        "
        :value="true"
      />
      <v-radio
        :label="
          $t(
            'events:EventCardLarge.CloneModal.entryRulesCloningSettings.takeFromTemplate.label',
            'Create competitions´ entry rule conditions from global template (if set)'
          )
        "
        :value="false"
      />
    </v-radio-group>
  </div>
</template>
<script setup>
import { computed } from "vue";
const props = defineProps({
  value: {
    type: Boolean,
    default: null
  }
});
const emit = defineEmits(["input"]);

const cloneValue = computed({
  get() {
    return props.value;
  },
  set(v) {
    emit("input", v);
  }
});
</script>
